




































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RadioGroup from '@ui/AudienceSetWizard/components/RadioGroup'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import StepNavigation from '@ui/AudienceSetWizard/StepNavigation'
import VenueOnsiteForm from './forms/VenueOnsiteForm'
import VenueRemoteForm from './forms/VenueRemoteForm'
import VenueOngoingForm from './forms/VenueOngoingForm'

settings =
  name: 'VenueFormStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      RadioGroup,
      StepContainer,
      StepNavigation,
      VenueOnsiteForm,
      VenueRemoteForm,
      VenueOngoingForm,
    }

    data: ->
      venueType: 'custom'
      selectedVenue: null
      selectedVenueKey: null

    computed:
      listingClass: ->
        listingsClasses =
          'venue-onsite-form': 'in_person'
          'venue-remote-form': 'remote'
          'venue-ongoing-form': 'ongoing'

        # listingClass = @wizard.audienceSetData.listing_class
        listingClass = listingsClasses[@step.name]
        listingClass

      venueOptions: ->
        for key, venue of @wizard.venues
          continue if @wizard.selectedAudienceAvailability?.venue_key is key
          { label: @$options.filters.formatVenueLocation(venue), value: key }

      optionsForVenueTypes: ->
        [
          { value: 'custom', label: 'Your venue'},
          { value: 'select', label: 'Select existing venue'},
        ]

      actionsForStepNavigation: ->
        beforeBack: @setVenue
        beforeNext: @setVenue

    mounted: ->
      if @wizard.selectedAudienceAvailability
        @selectedVenue = @wizard.audienceSetData.venues[@wizard.selectedAudienceAvailability.venue_key]
      else if !@wizard.selectedAudienceAvailabilityKey
        @initializeData()
      else
        @wizard.back()

    methods:
      hiChangeSelectedVenueKey: (venueKey) ->
        @selectedVenue = @wizard.audienceSetData.venues[venueKey]

      initializeData: ->
        @selectedVenue = @generateVenue()
        audienceAvailability = @generateAudienceAvailability()
        audienceAvailability.title = @wizard.audienceSetData.title
        @wizard.audienceSetData.audience_availabilities.push audienceAvailability
        @wizard.audienceSetData.listing_class = @listingClass
        @wizard.setSelectedAudienceAvailabilityKey audienceAvailability.key

      setVenue: () ->
        return unless @wizard.selectedAudienceAvailability
        return unless @selectedVenue
        @wizard.audienceSetData.venues[@selectedVenue.key] = @selectedVenue
        @wizard.selectedAudienceAvailability.venue_key = @selectedVenue.key

      generateVenue: ->
        type = 'remote_venue' if @step.name is 'venue-remote-form'
        type ||= 'in_person_venue'
        @wizard.prototypeForVenueType type

      generateAudienceAvailability: ->
        @wizard.prototypeForAudienceAvailability()

    watch:
      venueType: (value) ->
        if value is 'custom'
          @selectedVenue = @wizard.audienceSetData.venues[@wizard.selectedAudienceAvailability?.venue_key]
          @selectedVenue ||= @generateVenue()
        else
          @selectedVenue = null
          @selectedVenueKey = null

export default VueOptions.vue settings
